import { SourceIndexes } from './SourceConfig';

const hostname = window.location.hostname.replace('www.', '');
const isPreview =
  process.env.NODE_ENV === 'production' && hostname === 'kystverket-routeinfo.vercel.app';
const isProd =
  process.env.NODE_ENV === 'production' &&
  (hostname === 'routeinfo.no' || hostname === 'routeinfo.kystverket.no');
let isDevSite =
  process.env.NODE_ENV !== 'production' ||
  (hostname !== 'routeinfo.no' &&
    hostname !== 'routeinfo.kystverket.no' &&
    hostname !== 'kystverket-routeinfo.vercel.app');

// Default development endpoints, use development server.
let adaptiveUrl = 'https://a3routeinfo-dev.avinet.no/';
let adaptive4Url = 'https://kystverket.avadaptive.no/';
let a3WmsUrl = 'https://a3routeinfo-dev-ogc.avinet.no/wms.ashx';
let a4WmsUrl = 'https://kystverket.avadaptive.no/api/mapserver/v1/wms/routeinfo-wms';
let layerIds = {
  39: SourceIndexes.CPR, //Theme: 19 - Local restrictions when sailing with PEC (Pilotage Exemption Certificate)
  28: SourceIndexes.PORT, //Theme: 14 - Ports
  27: SourceIndexes.PORT_FACILITY, //Theme: 13 - Port facilities
  29: SourceIndexes.QUAY, //Theme: 15 - Quays
  36: SourceIndexes.ROUTE, //Theme: 17 - Reference routes for navigation
  25: SourceIndexes.MTR, //Theme: 11 - Navigation rules for specific waters (in VTS service areas)
  137: SourceIndexes.SVALBARD, //Theme: 26 - Regulations and Services - Svalbard (active)
  142: SourceIndexes.LFR, //  Theme: 28 - Pilot Guidelines
  cpr: 'local-reg-pec',
  port_without_svalbard: 'ports-without-svalbard',
  port_svalbard: 'ports-svalbard',
  port_facilities_without_svalbard: 'port-facilities-without-svalbard',
  port_facilities_svalbard: 'port-facilities-svalbard',
  quay_without_svalbard: 'quays-without-svalbard',
  quay_svalbard: 'quays-svalbard',
  routes: 'route-active-standard',
  mtr: 'local-reg-vts',
  pilot: 'pilot_boarding',
  approachCorridor: 'approach-corridors-for-pilotage',
  svalbard: 'regulations_services_svalbard_active',
  vts: 'vts-service-areas',
  lfr: 'layer_28', //  Theme: 28 - Pilot Guidelines
  anchoragePoint: 'active-anchorage-point-routeinfo',
  anchorageArea: 'active-anchorage-area',
  anchorageAreaCenterpoint: 'active-anchorage-area-centerpoint'
};

if (process.env.REACT_APP_LOCAL_SERVER) {
  // Local development endpoints
  //Not in use
}

if (isPreview || isProd) {
  // Production endpoints
  adaptiveUrl = 'https://a3cloud.kystverket.no/';
  adaptive4Url = 'https://kystverket.avadaptive.no/';
  a3WmsUrl = 'https://a3cloudmap.kystverket.no/wms.ashx';
  a4WmsUrl = 'https://kystverket.avadaptive.no/api/mapserver/v1/wms/routeinfo-wms';
  layerIds = {
    77: SourceIndexes.CPR, //Theme: 36 - Local restrictions when sailing with PEC (Pilotage Exemption Certificate)
    47: SourceIndexes.PORT, //Theme: 24 - Ports
    48: SourceIndexes.PORT_FACILITY, //Theme: 25 - Port facilities
    49: SourceIndexes.QUAY, //Theme: 26 - Quays
    51: SourceIndexes.ROUTE, //Theme: 28 - Reference routes for navigation
    52: SourceIndexes.MTR, //Theme: 29 - Navigation rules for specific waters (in VTS service areas)
    118: SourceIndexes.SVALBARD, //Theme: 49 - Regulations and Services - Svalbard (active)
    122: SourceIndexes.LFR, //Theme: 52 - Pilot Guidelines
    cpr: 'local-reg-pec',
    port_without_svalbard: 'ports-without-svalbard',
    port_svalbard: 'ports-svalbard',
    port_facilities_without_svalbard: 'port-facilities-without-svalbard',
    port_facilities_svalbard: 'port-facilities-svalbard',
    quay_without_svalbard: 'quays-without-svalbard',
    quay_svalbard: 'quays-svalbard',
    routes: 'route-active-standard',
    mtr: 'local-reg-vts',
    pilot: 'pilot_boarding',
    approachCorridor: 'approach-corridors-for-pilotage',
    svalbard: 'regulations_services_svalbard_active',
    vts: 'vts-service-areas',
    lfr: 'layer_52', //Theme: 52 - Pilot Guidelines
    anchoragePoint: 'active-anchorage-point-routeinfo',
    anchorageArea: 'active-anchorage-area',
    anchorageAreaCenterpoint: 'active-anchorage-area-centerpoint'
  };
  isDevSite = false;
}

export default window.KystverketConfig = {
  isDevSite,
  adaptiveUrl,
  adaptive4Url,
  a3WmsUrl,
  a4WmsUrl,
  terms_consent: 'route_info-terms',
  privacy_consent: 'route_info-privacy',
  accept_email_consent: 'route_info-email',
  basename: '/',
  cmsSite: 0,
  srid: 3857,
  extent: [967135.3121703134, 8139424.406603873, 1685643.3780509701, 8950879.898879305],
  mapProjCode: '3857',
  dataProjCode: '32633',
  appName: 'Kystverket: Ruter',
  layerIds,
  themes: {
    port: {
      //Ports
      id: 'locationid',
      ssn: 'ssn_ports',
      theme_uuid: '6e34448a-606d-478c-b962-42379dbd6148',
      dataset_alias: 'ports',
      columns: [
        'locationid',
        'councilname',
        'locationcode',
        'locationnamenor',
        'locationnameeng',
        'geom'
      ],
      url: '/view/port/',
      searchResultOrder: 1
    },
    portfacility: {
      //Port facilities
      id: 'locationid',
      ssn: 'ssn_port_facilities',
      theme_uuid: '3b08550c-dec3-40cf-9f98-e9ec0d400b20',
      dataset_alias: 'port_facilities',
      columns: [
        'locationid',
        'councilname',
        'portfacilityno',
        'locationcode',
        'locationnamenor',
        'locationnameeng',
        'geom'
      ],
      url: '/view/portfacility/',
      searchResultOrder: 2
    },
    quay: {
      //Quays
      id: 'locationid',
      ssn: 'ssn_quays',
      theme_uuid: '7bfa118f-4d06-460c-88a9-ad6b24f3ff59',
      dataset_alias: 'quays',
      columns: [
        'locationid',
        'councilname',
        'locationcode',
        'locationnamenor',
        'locationnameeng',
        'geom'
      ],
      url: '/view/quay/',
      searchResultOrder: 3
    },
    route: {
      //Reference routes for navigation
      id: 'route_number',
      theme_uuid: '4e7e923f-3735-4faf-a63d-6495ab3a78fc',
      dataset_alias: 'route-active-standard',
      columns: [
        'auto_length',
        'ssn_port_facilities',
        'ssn_ports',
        'ssn_quays',
        'id',
        // 'routename', //missing
        // 'routeinfo_routename', //*
        'route_name',
        'extension_routenumber',
        // 'routequalitystatus',
        'route_quality_status',
        'routeinfo_vesselvoyage',
        // 'routeinfo_validityperiodstart',
        // 'validity_period_start',
        'route_line'
      ],
      url: '/view/route/',
      searchResultOrder: 5
    },
    mtr: {
      //Navigation rules for specific waters (in VTS service areas)
      id: 'id',
      theme_uuid: 'd5de6bf5-bbc7-41b4-858b-effe06ff6112',
      dataset_alias: 'local-reg-vts',
      columns: ['id', 'geom', 'section', 'region', 'link', 'factsheet'],
      url: '/view/mtr/',
      searchResultOrder: 6
    },
    cpr: {
      //Local restrictions when sailing with PEC (Pilotage Exemption Certificate)
      id: 'id',
      theme_uuid: 'e1ec4fa1-ca1c-44cd-ae51-6c8025d9d6d6',
      dataset_alias: 'local-reg-pec',
      columns: [
        'id',
        'name',
        'geom',
        'maritimedivisionname',
        'c23_day_maxlength',
        'c23_night_maxlength',
        'c23_day_maxdraught',
        'c23_night_maxdraught',
        'c1_day_maxlength',
        'c1_night_maxlength',
        'c1_day_maxdraught',
        'c1_night_maxdraught',
        'remarkenglish',
        'sok_kl1',
        'c1_dp'
      ],
      url: '/view/cpr/',
      searchResultOrder: 7
    },
    vts: {
      //VTS service areas
      id: 'id',
      theme_uuid: 'bb63fa52-487f-4b22-8061-cf4c02ea4b3e',
      dataset_alias: 'vts-service-areas',
      inSearch: false,
      columns: ['id', 'areaname_eng', 'factsheet']
    },
    pilotBoarding: {
      //Pilot boarding (theme ut som WMS i Frontend)
      id: 'id',
      theme_uuid: '82bc4664-3ff7-4aac-bc74-29d8e2c93349',
      dataset_alias: 'pilot_boarding',
      inSearch: false,
      columns: []
    },
    svalbard: {
      //Svalbard, Regulations and Information Services
      id: 'id',
      theme_uuid:
        isProd || isPreview
          ? '0fb2beae-823b-47a7-8939-042fe5de422a'
          : 'eda583a1-4414-4fe4-b44d-98b525270179',
      dataset_alias: 'regulations_services_svalbard_active',
      columns: ['id', 'geom', 'name', 'factsheet', 'link', 'description'],
      url: '/view/svalbard/',
      searchResultOrder: 8
    },
    lfr: {
      // Pilot Guidelines
      id: 'id',
      theme_uuid:
        isProd || isPreview
          ? 'a6a6dfad-84e0-401b-922c-68374aa8149d'
          : '00633c53-817f-43c9-a860-31a84e94052d',
      columns: ['id', 'title', 'text_en', 'maritime_division'],
      url: '/view/lfr/'
    },
    anchorage: {
      //Anchorage
      id: 'id',
      dataset_alias: 'dok-anchoragearea',
      columns: [
        'anchoragename',
        'dok_name',
        'reportingname',
        'unlocationcode',
        'mainmunicipality',
        'nni_text',
        'voyagereporting',
        'voyagereporting/voyagereportingname',
        'voyagereporting/website',
        'vts',
        'vts/vtsname',
        'vts/phone',
        'vts/email',
        'vts/vhf',
        'pilotage',
        'pilotage/pilotagename',
        'pilotage/pilotageinfo',
        'pilotage/phone',
        'port',
        'port/portname',
        'port/phone',
        'tug',
        'tug/tugname',
        'tug/phone',
        'geom'
      ],
      url: '/view/anchorage/',
      searchResultOrder: 4,
      sort: 'anchoragename'
    }
  }
};
